var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReceipt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "receipt",
    transform: "translate(-2.79 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_315",
    "data-name": "Union 315",
    d: "M7.4,15.883,6,14.924l-1.4.959a.666.666,0,0,1-.753,0l-1.4-.959-1.4.959A.667.667,0,0,1,0,15.333v-12A3.337,3.337,0,0,1,3.333,0H8.666A3.338,3.338,0,0,1,12,3.334v12a.667.667,0,0,1-1.042.549l-1.4-.958-1.4.959a.665.665,0,0,1-.754,0ZM6.379,13.565l1.4.959,1.4-.959a.666.666,0,0,1,.754,0l.734.5V3.334a2,2,0,0,0-2-2H3.333a2,2,0,0,0-2,2V14.066l.739-.5a.666.666,0,0,1,.753,0l1.4.959,1.4-.959a.666.666,0,0,1,.754,0ZM3.333,9.333A.667.667,0,0,1,3.333,8h4a.667.667,0,0,1,0,1.334Zm0-2.667a.667.667,0,1,1,0-1.333H8.666a.667.667,0,1,1,0,1.333Z",
    transform: "translate(2.79 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceipt);
export default __webpack_public_path__ + "static/media/receipt.cba1622c5523a396465f81387d973571.svg";
export { ForwardRef as ReactComponent };